import Div from '@hellodarwin/core/lib/components/common/div';
import { useTheme } from 'styled-components';
import GrantsDirectoryTotal from '../../../../../../components/funding-explorer/grants-directory-total';
import useOnboardingFlow from '../../../../hooks/useOnboardingFlow';
import useTemplate from '../../../../hooks/useTemplate';
import { StepContentForm } from './styles';
import OnboardingLayoutFormContainerWrapper from './wrapper';

interface OnboardingLayoutFormContainerProps {
  handleFormChange: () => void;
}
const OnboardingLayoutFormContainer: React.FC<
  OnboardingLayoutFormContainerProps
> = ({ handleFormChange }) => {
  const { onboardingForm, currentStepContent } = useOnboardingFlow();

  const { loadingTemplate, Template } = useTemplate();
  const theme = useTheme();

  return (
    <StepContentForm
      form={onboardingForm}
      layout="vertical"
      onValuesChange={handleFormChange}
      id="step-content-form"
      style={{ justifyContent: 'center' }}
    >
      {!!currentStepContent && Template && !loadingTemplate && (
        <OnboardingLayoutFormContainerWrapper>
          <Template />
        </OnboardingLayoutFormContainerWrapper>
      )}
      {!!currentStepContent &&
        !loadingTemplate &&
        currentStepContent.template === 'Form' && (
          <Div
            style={{
              minHeight: theme.fontsLineHeights.h5,
              alignItems: 'center',
              justifyContent: 'center',
            }}
            flex="column"
          >
            <GrantsDirectoryTotal elementTheme="h5" />
          </Div>
        )}
    </StepContentForm>
  );
};

export default OnboardingLayoutFormContainer;
